import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate, useLocation } from "react-router-dom";
import SidePanel from "./SidePanel";
import VideoArenaAppBody from "./VideoArenaAppBody";
import AboutUs from "./AboutUs";
import Leaderboard from "./Leaderboard";
import GenerateModal from "./GeneratePage";
import Library from "./Library";
import GeneratedPage from "./GeneratedPage";
import "./VideoArenaApp.css";

// Define a simple 404 component
function NotFound() {
  return (
    <div className="not-found-container">
      <h1>404: Page Not Found</h1>
    </div>
  );
}

function VideoArenaApp() {
  const dev = false;
  const VideoArenaAppRef = useRef("VideoArenaAppRef");
  const [userId, setUserId] = useState("");
  const [library, setLibrary] = useState([]);
  const [curVid, setCurVid] = useState(null);
  const [generate, toggleGenerate] = useState(false);
  const baseURL = dev ? "http://127.0.0.1:8080" : "https://www.videoarena.tv";

  useEffect(() => {
    console.log("----- enter VideoArenaApp");

    return () => {
      console.log("----- exit VideoAreanApp");
    };
  }, []);

  return (
    <Router>
      <div id="VideoArenaApp" ref={VideoArenaAppRef} className="VideoArenaApp">
        <SidePanel
          userId={userId}
          setUserId={setUserId}
          baseURL={baseURL}
          library={library}
          setLibrary={setLibrary}
          curVid={curVid}
          setCurVid={setCurVid}
          toggle={toggleGenerate}
        />

        <Routes className="VideoArenaApp-body">
          <Route
            path="/"
            element={
              <VideoArenaAppBody
                userId={userId}
                generate={generate}
                baseURL={baseURL}
                language="ENGLISH"
              />
            }
          />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/leaderboard" element={<Leaderboard baseURL={baseURL} />} />
          <Route
            path="/cn"
            element={
              <VideoArenaAppBody
                userId={userId}
                generate={generate}
                baseURL={baseURL}
                language="CHINESE"
              />
            }
          />
          {/* <Route path="/library" element={<Library type='page' userId={userId} library={library} setCurVid={setCurVid} />} /> */}
          {/* <Route path="/library/event" element={<Outlet />} /> */}
          {/* <Route path="/generatedpage" element={<GeneratedPage userId={userId} generate={generate} curVid={curVid} />} /> */}
          {/* Catch all undefined routes and display 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        <GenerateModal
          userId={userId}
          baseURL={baseURL}
          library={library}
          setLibrary={setLibrary}
          display={generate}
          toggle={toggleGenerate}
        />
      </div>
    </Router>
  );
}

export default VideoArenaApp;
